import { Validator } from './validator';

export class QuantityAddonValidator implements Validator {

    private id = '';

    constructor(id: string) {
        this.id = id;
    }

    validate(): Promise<boolean> {
        const quantityInput = document.querySelector(`#df_${this.id}_quantity`) as HTMLSelectElement;
        const isValid = Number(quantityInput.value) > 0;
        return Promise.resolve(isValid);
    }

}
